<template>
    <section class="app-main">

        <div class="top-bar">
            <!-- <el-date-picker v-model="date" type="date"  value-format="yyyy-MM-dd" placeholder="申请日期"></el-date-picker> -->
            <el-input placeholder="搜索商家名称或手机号" v-model="search"  style="width:300px;" @change="getData" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>

        <el-card>
            <el-table :data="tableData" v-loading="table_load" height="600">
                <el-table-column  prop="corporate_name"    label="商家名称"    width="200" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  prop="email"    label="企业邮箱"    width="200" align="center" > </el-table-column>
                <el-table-column  prop="batch"    label="企业联系人"  width="180" align="center">
                    <template slot-scope="scope">
                        <el-link type="info">{{scope.row.surname}} {{scope.row.name}} </el-link>
                    </template>
                </el-table-column>
                <el-table-column  prop="phone"    label="联系电话"    width="180" align="center"></el-table-column>
                <el-table-column  prop="cid_title" label="经营类目"    width="180" align="center" ></el-table-column>
                <el-table-column  prop="updated_at" label="申请时间"   width="180"  align="center" ></el-table-column>
                <el-table-column   label="编辑"   width="180"  align="center" >
                    <template slot-scope="scope">
                        <p><el-button size="small" @click="startCheck(scope.row)">查看信息</el-button></p>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper" style="padding:10px" :page-size="size" :total="total"  @current-change="loadPage"></el-pagination>
        </el-card>


        <el-dialog title="申请信息表" :visible.sync="edit_modal" :show-close="false" width="1000px" align="center">
            <el-card class="m-bottom-4">
                 <el-row :gutter="20" style="margin-bottom:10px">
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="4" class="shop-title">{{row.shops_type == 1 ? '企业名称' : '店铺名称' }}</el-col>
                            <el-col :span="20" class="shop-info">{{row.corporate_name}}</el-col>
                        </el-row>
                    </el-col >
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="4" class="shop-title">企业联系人</el-col>
                            <el-col :span="20" class="shop-info">{{row.surname}} {{row.name}}</el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:10px" >
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="4" class="shop-title">经营类目</el-col>
                            <el-col :span="20" class="shop-info">{{row.cid_title}}</el-col>
                        </el-row>
                    </el-col >
                    <!-- <el-col :span="12">
                        <el-row >
                            <el-col :span="4" class="shop-title">联系人职务</el-col>
                            <el-col :span="20" class="shop-info">{{row.post}}</el-col>
                        </el-row>
                    </el-col> -->
                </el-row>
                <el-row :gutter="20" style="margin-bottom:20px" >
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="4" class="shop-title">联系邮箱</el-col>
                            <el-col :span="20" class="shop-info">{{row.email}}</el-col>
                        </el-row>
                    </el-col >
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="4" class="shop-title">联系电话</el-col>
                            <el-col :span="20" class="shop-info">{{row.phone}}</el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row  v-if="row.country">
                    <p class="shop-title">企业发货地址：{{row.addr}} {{row.city.ename}}-{{row.province.ename}}-{{row.country.ename}}</p>
                </el-row>
            </el-card>

            <el-card class="m-bottom-4">
                <el-row  v-if="row.shops_type == 1">
                    <el-col :span="2" class="img-title">营业执照</el-col>
                    <el-col :span="22" class="imgs-box">
                        <m-img  :src="row.license_pic_url" :width="160" :height="160" />
                    </el-col>
                </el-row>
                <el-row style="margin-bottom:20px" v-if="row.shops_type == 0">
                    <el-col :span="2" class="img-title">身份认证</el-col>
                    <el-col :span="22" class="imgs-box">
                        <m-img  :src="row.id_card_pic_one_url" />
                        <m-img  :src="row.id_card_pic_two_url" />
                    </el-col>
                </el-row>
            </el-card>

             <el-card class="m-bottom-4">
                <el-row  >
                    <el-col :span="2" class="img-title">拒绝原因</el-col>
                    <el-col :span="22" class="img-title">{{row.refusal_reasons}}</el-col>
                </el-row>
            
            </el-card>
           
            




        </el-dialog>


    </section>
</template>



<script>
import { shops, shops_audit } from '@/api/merchant.js'
import MImg   from './../../../components/Image'

export default {
    components: { MImg },
    data() {
        return {

            page:1,
            total:0,
            size: 20,
            search: '',
            tableData:[],
            row:{},
            edit_modal: false,
            innerVisible: false,
            rate: '',
            pack: 0,
            reasons:'',
        }
    },
    methods: {
        getData(){
            let params = {
                page: this.page
            }
            if(this.search != '') {
                params.search = this.search
            }
            shops(2, params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                }
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
        startCheck(row){
            this.row = row;
            this.edit_modal = true;
        },
        scaleImg(url){
            this.dialogVisible = true;
            this.dialogImageUrl = url;
        },
        refuse(type){
            if(type == 1){
                this.innerVisible = true;
            }else{
                if(this.reasons == ""){
                    this.$message.error('请先输入驳回原因...')
                    return false;
                }
                let params = {
                    refusal_reasons:this.reasons,
                }
                this.innerVisible = false;
                this.edit_modal = false;
                shops_audit(this.row.id ,params).then(res => {
                    if (res.status == 1) {
                        this.$message({message:res.msg,type:"success",offset:'200'})
                        this.getData();
                        
                    }else{
                        this.$message({message:res.msg,type:"error",offset:'200'})
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
            
        },
        agree(){

            let params = {
                status: 1,
            }
            this.innerVisible = false;
            this.edit_modal = false;
            shops_audit(this.row.id ,params).then(res => {
                if (res.status == 1) {
                    this.$message({message:res.msg,type:"success",offset:'200'})
                    this.getData();
                }else{
                    this.$message({message:res.msg,type:"error",offset:'200'})
                }
            }).catch(err => {
                console.log(err)
            })
        }
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
.shop-title {
    text-align: left;
    height: 40px;
    line-height: 40px;
}
.img-title {
    text-align: left;
    height: 70px;
    line-height: 70px;
}
.shop-info {
    border: 1px solid #e0e0e0;
    text-align: left;
    padding-left: 10px;
    height: 40px;
    line-height: 40px;
    border-radius: 3px;
}
.imgs-box {
    text-align: left;
}



</style>

